import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "capital-sign",
  data: function data() {
    return {
      searchForm: {
        pageNum: 1,
        pageSize: 20,
        id: '',
        contractCode: '',
        landlordName: '',
        landlordPhone: '',
        tenantName: '',
        tenantPhone: '',
        status: ''
      },
      tableData: [{}],
      contractUrl: '',
      drawer: false
    };
  },
  mounted: function mounted() {
    this.searchForm.contractCode = this.$route.query.contractCode || '';
    this.getData();
  },
  methods: {
    resetSearch: function resetSearch() {
      this.searchForm = {
        pageNum: 1,
        pageSize: 20,
        id: '',
        landlordName: '',
        landlordPhone: '',
        tenantName: '',
        tenantPhone: '',
        status: ''
      };
      this.getData('search');
    },
    getData: function getData(type) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (type === "search") {
                _this.searchForm.pageNum = 1;
              }
              _this.tableLoading = true;
              _context.n = 1;
              return _this.$api.getOrderContractList(_this.searchForm);
            case 1:
              res = _context.v;
              _this.tableData = res.data.content;
              _this.total = res.data.totalSize;
              _this.tableLoading = false;
              _this.getUserListByIds(_this.tableData, "landlordId", "tenantId", "landlordInfo", "tenantInfo");
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pageNum = pn;
      this.getData();
    },
    viewContract: function viewContract(id) {
      this.contractUrl = "http://m.well-see.com/sign/contract?id=".concat(id, "&lang=zh&openType=preview");
      // window.open(`http://m.well-see.com/sign/contract?id=${id}&lang=zh&openType=preview`, '_blank', 'width=900,height=800,toolbar=no,menubar=no,status=no');
      this.drawer = true;
    }
  }
};